<template>
  <div>
    <div class="box4">
      <div class="provinceBox">
        <select
          placeholder="省份"
          v-model="demo01"
          v-on:change="onChange($event)"
          class="address"
        >
          <!--<option :value="defaultValue" selected v-if="!$auth('warehourse.local')">全国</option>-->
          <option
            v-for="item in provinceArr"
            :key="item.name"
            :value="item.provinceId"
          >
            {{ item.name }}
          </option>
        </select>
        <span class="jt"><Icon type="icon-jiantouxia"></Icon></span>
      </div>
      <div class="searchImgBox">
        <svg class="searchImg" aria-hidden="true">
          <use xlink:href="#icon-sousuo"></use>
        </svg>
      </div>

      <div class="searchBox flex1">
        <input
          class=" searchInput"
          type="text"
          v-on:input="inputValue"
          placeholder="搜索"
          v-model="searchName"
        />
      </div>
      <div class="mapBox" @click="$router.push('/warehouse/map')">
        <Icon type="icon-ditu" class="mapImg"></Icon>
      </div>
    </div>

    <div class="box2">
      <main class="position-box">
        <scroller
          class="wrapper"
          ref="scroll"
          :lazyLoad="true"
          :loadData="loadData"
        >
          <template v-slot="{ item }">
            <li class="list-item" style="overflow: hidden;display: block">
              <a
                @click="
                  $router.push('/WarehouseDetail/' + item.id + '/storehouseInf')
                "
              >
                <div class="box">
                  <div class="pic">
                    <Thumb
                      class="picImg"
                      :src="
                        item.file &&
                        item.file.fileDetails &&
                        item.file.fileDetails.length > 0
                          ? item.file.fileDetails[0].fileUrl
                          : ''
                      "
                    ></Thumb>
                  </div>
                  <!--<div class="pic" v-if="item.file && item.file.fileDetails && item.file.fileDetails.length>0">-->
                  <!--<Thumb class="picImg" :src="item.file.fileDetails[0].fileUrl"></Thumb>-->
                  <!--</div>-->
                  <!--<div class="pic" v-else>-->
                  <!--<img class="picImg"  src="../../assets/bglogo.png">-->
                  <!--</div>-->
                  <div class="content flex1">
                    <div class="warehouseName">
                      {{ item.warehouseName }}
                      <Icon
                        type="icon-jiankong"
                        class="warehouseImg"
                        v-if="item.type != null && item.deviceStatus === 50"
                      ></Icon
                      ><!--<img class="warehouseImg">-->
                    </div>
                    <!--<div class="usedWareouse">已用库位</div>-->
                    <div class="usedWareouse"></div>
                    <div>
                      <span class="warehouseText">
                        <!--<span class="warehouseYellow">{{item.usedArea==null?0 :item.usedArea}} m²</span> / <span>{{item.totalArea==null?0:item.totalArea}} m²</span>-->
                        库容大小:<span
                          >{{
                            item.totalArea == null ? 0 : item.totalArea
                          }}
                          m²</span
                        >
                      </span>
                      <!--<span class="warehouseWeight"><Icon type="icon-kucun" class="weightImg"></Icon>-->
                      <!--&lt;!&ndash;<img class="weightImg">&ndash;&gt;{{item.availableWeight==null?0:item.availableWeight}} 吨</span>-->
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </template>
        </scroller>
      </main>
    </div>
    <div class="add" @click="$router.push('/warehouse/warehouseAdd')">
      <img src="~@/assets/add@2x.png" alt="" />
    </div>

    <div class="close" v-show="showMap" @click="showMap = false">关闭</div>
  </div>
</template>
<script>
import Scroller from "@/components/Scroller";
import { debounce } from "vux";
import { pageWarehouse } from "@/api/module/api-warehouse";
import { queryProvinceGroup } from "@/api/module/api-address";
import { getUserOrgInfo } from "@/api/module/user";
import Thumb from "@/components/Thumb/Thumb";

export default {
  components: {
    Scroller,
    Thumb
  },
  data() {
    return {
      warehouseArr: [],
      page: 1, // 当前页
      limit: 10,
      value: "",
      results: [],
      list: [
        { key: "gd", value: "广东" },
        { key: "gx", value: "广西" }
      ],
      demo01: "",
      provinceArr: [],
      showMap: false,
      defaultValue: "",
      isPull: false,
      searchName: "",
      loadData: params => {
        return pageWarehouse(
          Object.assign({}, params, {
            warehouseName: this.searchName,
            provinceId: this.demo01
          })
        );
      }
    };
  },
  created() {
    this.queryProvinceGroup();
  },
  mounted() {},
  methods: {
    getData() {
      this.$refs["scroll"].getList(true);
    },
    onChange(e) {
      this.demo01 = e.target.value;
      this.getData();
    },
    queryProvinceGroup() {
      const that = this;
      const params = {};
      queryProvinceGroup(params)
        .then(response => {
          that.provinceArr = response;
          that.getUserOrgInfo();
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    inputValue: debounce(function(e) {
      this.searchName = e.target.value;
      this.getData();
    }, 500),
    getUserOrgInfo() {
      const params = {};
      const that = this;
      getUserOrgInfo(params)
        .then(response => {
          that.demo01 = response.provinceCode;
          // 刷新
          this.getData();
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    scrollTo() {
      this.$refs.scroll.scrollTo(
        this.scrollToX,
        this.scrollToY,
        this.scrollToTime
      );
    }
  }
};
</script>

<style scoped>
select {
  border: none;
  -webkit-appearance: none;
}

.close {
  position: fixed;
  z-index: 9999;
  top: 20px;
  left: 20px;
  width: 120px;
  height: 60px;
  line-height: 60px;
  background: #2f84f7;
  color: #fff;
  border-radius: 5px;
  font-size: 14px;
  text-align: center;
}

.flex1 {
  flex: 1;
}

.box1 {
  height: 100px;
  position: relative;
  width: 1490px;
}

.box1-item {
  width: 200px;
  height: 100px;
  background-color: #ccc;
  display: inline-block;
  margin-left: 15px;
  float: left;
  text-align: center;
  line-height: 100px;
}

.box1-item:first-child {
  margin-left: 0;
}

.box2-wrap {
  height: 300px;
  overflow: hidden;
}

.box {
  display: flex;
  padding: 20px 30px;
  overflow: hidden;
  border-bottom: 1px solid rgba(232, 232, 232, 1);
  background: #fff;
}

.pic {
  width: 200px;
  height: 150px;
  display: block;
}

.content {
  margin-left: 20px;
}

.warehouseName {
  color: #262626;
  font-size: 15px;
  line-height: 30px;
}

.usedWareouse {
  color: #ababab;
  font-size: 11px;
  height: 22px;
  overflow: hidden;
  line-height: 22px;
  margin-top: 40px;
  margin-bottom: 15px;
}

.warehouseText {
  color: #5e5e5e;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  display: block;
  float: left;
}

.warehouseYellow {
  color: #ff8305;
  font-size: 20px;
}

.warehouseWeight {
  float: right;
  margin-right: 0;
  color: #5e5e5e;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
}

.box4 {
  display: flex;
  overflow: hidden;
  background: #fff;
  border-bottom: 1px solid rgba(232, 232, 232, 1);
  position: fixed;
  /*top:90px;*/
  left: 0px;
  z-index: 2;
  width: 100%;
}

.warehouseImg {
  width: 20px;
  height: 24px;
  margin-left: 10px;
}

.weightImg {
  font-size: 12px;
  margin-right: 20px;
}

.provinceBox {
  max-width: 300px;
  height: 88px;
  overflow: hidden;
}

.searchBox {
  margin: 14px 0;
  padding: 10px 20px;
  height: 40px;
  line-height: 40px;
  background: rgba(242, 244, 247, 1);
  font-size: 13px;
}

.searchInput {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border: none;
  font-size: 14px;
  background: rgba(242, 244, 247, 1);
  margin: 0;
  padding: 0;
  outline: none !important;
  display: inline-block;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  vertical-align: top;
}

.searchInput::placeholder {
  margin: 0;
  padding: 0;
}

.searchImg {
  width: 30px;
  height: 30px;
  vertical-align: top;
  fill: currentColor;
  overflow: hidden;
  color: #919191;
}

.mapBox {
  width: 40px;
  height: 40px;
  margin: 24px 28px;
  overflow: hidden;
}

.mapImg {
  font-size: 20px;
  line-height: 40px;
}

.searchImgBox {
  width: 30px;
  height: 30px;
  margin: 14px 0;
  padding: 15px 0 15px 20px;
  background: rgba(242, 244, 247, 1);
}

.picImg {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.add {
  position: fixed;
  width: 90px;
  height: 90px;
  right: 37px;
  bottom: 170px;
  z-index: 999;
}

.add img {
  width: 100%;
  height: 100%;
}

.map {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 999;
}

.address {
  height: 80px;
  line-height: 80px;
  font-size: 14px !important;
  border: none;
  margin-left: 10px;
  background: #fff;
}

.jt {
  font-size: 12px;
  margin-right: 5px;
}

.refresh {
  position: fixed;
  width: 90px;
  height: 90px;
  right: 37px;
  bottom: 400px;
  z-index: 999;
  background: #0bb20c;
}

.more {
  position: fixed;
  width: 90px;
  height: 90px;
  right: 37px;
  bottom: 300px;
  z-index: 999;
  background: red;
}

.position-box {
  position: fixed;
  top: 180px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

@media screen and (max-width: 320px) {
  .box4 {
    top: 46px;
  }

  .mapBox {
    width: 20px;
    height: 20px;
    margin: 10px 14px;
    overflow: hidden;
  }
}
</style>
